// extracted by mini-css-extract-plugin
export default {"container":"AuthFormLabel_container__9lJNz"};